import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AdminDashboardComponent } from "./admin-dashboard/admin-dashboard.component";

import { AuthGuard } from "../auth.guard";
import {ListPharmaComponent} from "../list-pharma/list-pharma.component";
import {AdminComponent} from "./admin.component";
import {AddPharmaComponent} from "../add-pharma/add-pharma.component";
import {AddLaboComponent} from "../add-labo/add-labo.component";
import {ListLaboComponent} from "../list-labo/list-labo.component";
import {ListCampaignComponent} from "../list-campaign/list-campaign.component";
import {AddCampaignComponent} from "../add-campaign/add-campaign.component";
import {RecapCampaignComponent} from "../recap-campaign/recap-campaign.component";
import {ListContractComponent} from "../list-contract/list-contract.component";
import {AddContractComponent} from "../add-contract/add-contract.component";
import {ValidateContractComponent} from "../validate-contract/validate-contract.component";
import {ValidateCampaignComponent} from "../validate-campaign/validate-campaign.component";
import {ListUserComponent} from "../list-user/list-user.component";
import {DetailContractComponent} from "../detail-contract/detail-contract.component";
import {ListPromotionComponent} from "../list-promotion/list-promotion.component";
import {ListProductComponent} from "../list-product/list-product.component";
import {AddProductComponent} from "../add-product/add-product.component";
import {DetailPromotionComponent} from "../detail-promotion/detail-promotion.component";
import {ListOrderComponent} from "../list-order/list-order.component";
import {DetailOrderComponent} from "../detail-order/detail-order.component";
import {ListAdminComponent} from "../list-admin/list-admin.component";
import {AddAdminComponent} from "../add-admin/add-admin.component";
import {AddBillComponent} from "../add-bill/add-bill.component";
import {ListBillComponent} from "../list-bill/list-bill.component";
import {ValidateBillComponent} from "../validate-bill/validate-bill.component";
import {DetailBillComponent} from "../detail-bill/detail-bill.component";
import {NotificationCenterComponent} from "../notification-center/notification-center.component";
import {AddHashtingComponent} from "../add-hashting/add-hashting.component";
import {ListHashtingComponent} from "../list-hashting/list-hashting.component";
import {RecapHashtingComponent} from "../recap-hashting/recap-hashting.component";

const adminRoutes: Routes = [
  {
    path: 'administration',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        canActivateChild: [AuthGuard],
        children: [
          /* DASHBOARD */
          { path: 'home', component: AdminDashboardComponent },
          /* DASHBOARD END */

          /* PHARMACIES */
          { path: 'pharmacies/ajouter', component: AddPharmaComponent },
          { path: 'pharmacies/modifier/:id', component: AddPharmaComponent },
          { path: 'pharmacies/modifier', redirectTo: 'pharmacies/ajouter' },
          { path: 'pharmacies', component: ListPharmaComponent },
          /* PHARMACIES END */

          /* LABORATOIRES */
          { path: 'laboratoires/ajouter', component: AddLaboComponent },
          { path: 'laboratoires/modifier/:id', component: AddLaboComponent },
          { path: 'laboratoires/modifier', redirectTo: 'laboratoires/ajouter' },
          { path: 'laboratoires', component: ListLaboComponent },
          { path: 'mon-compte', component: AddLaboComponent },
          /* LABORATOIRES END */

          /* CAMPAGNES */
          { path: 'campagnes', component: ListCampaignComponent },
          { path: 'campagnes/ajouter', component: AddCampaignComponent },
          { path: 'campagnes/recapitulatif/:id', component: RecapCampaignComponent },
          { path: 'campagnes/validation/:id/:sort/:revert/:page/:search', component: ValidateCampaignComponent },
          /* CAMPAGNES END */

          /* HASHTING */
          { path: 'hashting', component: ListHashtingComponent },
          { path: 'hashting/ajouter', component: AddHashtingComponent },
          { path: 'hashting/recapitulatif/:id', component: RecapHashtingComponent },
          // { path: 'campagnes/recapitulatif/:id', component: RecapCampaignComponent },
          // { path: 'campagnes/validation/:id/:sort/:revert/:page/:search', component: ValidateCampaignComponent },
          /* HASHTING END */

          /* CONTRATS */
          { path: 'contrats', component: ListContractComponent },
          { path: 'contrats/ajouter', component: AddContractComponent },
          { path: 'contrats/valider', component: ValidateContractComponent },
          { path: 'contrats/details/:id', component: DetailContractComponent },
          /* CONTRATS END */

          /* PRODUCTS */
          { path: 'produits', component: ListProductComponent },
          { path: 'produits/ajouter', component: AddProductComponent },
          { path: 'produits/modifier/:id', component: AddProductComponent },
          { path: 'produits/modifier', redirectTo: 'produits/ajouter' },
          /* PRODUCTS END */

          /* PROMOTIONS */
          { path: 'promotions', component: ListPromotionComponent },
          { path: 'promotions/detail/:id', component: DetailPromotionComponent },
          /* PROMOTIONS END */

          /* ORDERS */
          { path: 'commandes', component: ListOrderComponent },
          { path: 'commandes/detail/:id', component: DetailOrderComponent },
          /* ORDERS END */

          /* BILLS */
          { path: 'factures', component: ListBillComponent },
          { path: 'factures/ajouter', component: AddBillComponent },
          { path: 'factures/modifier/:id', component: AddBillComponent },
          { path: 'factures/modifier', redirectTo: 'factures/ajouter' },
          { path: 'factures/valider', component: ValidateBillComponent },
          { path: 'factures/details/:id', component: DetailBillComponent },
          /* BILLS END */

          /* USERS */
          { path: 'administrateurs', component: ListAdminComponent },
          { path: 'administrateurs/ajouter', component: AddAdminComponent },
          { path: 'administrateurs/modifier/:id', component: AddAdminComponent },
          { path: 'administrateurs/modifier', redirectTo: 'administrateurs/ajouter' },
          { path: 'utilisateurs', component: ListUserComponent },
          /* USERS END */

          /* NOTIFICATIONS */
          { path: 'notifications', component: NotificationCenterComponent },
          /* NOTIFICATIONS END */

          /* DEFAULT REDIRECT */
          { path: '**', redirectTo: 'home', pathMatch: 'full' }
          /* DEFAULT REDIRECT END */
        ]
      }
    ]
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(adminRoutes) ],
  exports: [ RouterModule ]
})
export class AdminRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/admin/admin-routing.module.ts